<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from './ConstructionFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Construction neuve (maison, immeuble…)`,
        `Rénovation / réhabilitation`,
        `Travaux de gros œuvre`,
        `Travaux de second œuvre`,
        `Aménagement intérieur ou extérieur`,
        `Urbanisme / aménagement foncier`,
        `Autre (précisez ci-dessous)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const buildingTypeOptions = [
        `Maison individuelle`,
        `Immeuble résidentiel`,
        `Local commercial ou bureau`,
        `Établissement scolaire / santé`,
        `Infrastructure publique`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet souhaitez-vous réaliser ?`}
        helpLabel="Maximum 3 choix"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @4xl:grid-cols-2 gap-x-8"
            choices={projectTypeOptions}
            max={3}
        />
    </Row>

    <Row
        {form}
        field={fields.buildingType}
        class=""
        let:field
        let:id
        label={`Pour quel type de bâtiment ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={buildingTypeOptions}
        />
    </Row>
</div>
